import { SensorData } from 'Simulations/SensorPoint';
import { FilterStage, StageParameters } from '../../Stage';
import Grid from 'Geodata/grid';
import { StageContext } from '../../Context';

export interface CloseToTerrainParameters extends StageParameters {
    minValue: number;
    maxValue: number;
}

class CloseToTerrainStage extends FilterStage<CloseToTerrainParameters> {
    protected filter(sensorData: SensorData, _context: StageContext): boolean {
        // Get the sensor data:
        const index = sensorData.getSensorPoint().index;

        // Update isActive:
        // The following line is not taking in consideration the case in which sensor at Z==0 is not on the ground, but is floating.
        // In that case, we don't know the delta between the first sensor and the ground.
        // Probably we need to implement a quadtree to compute the height of a point on the ground
        const sensorHeight = Grid.gridRes + Grid.indexToXYZ(index)[2] * Grid.gridRes;
        const greaterThanMin = sensorHeight >= this.getParams().minValue;
        const lowerThanMax = sensorHeight <= this.getParams().maxValue;
        return greaterThanMin && lowerThanMax;
    }
}

export default CloseToTerrainStage;
